/**
 * Records if the user will effectively have access to
 * device orientation for controlling the 360 video as
 * not all browsers will support it and some (iOS 13+)
 * and some behaviour (requesting permission and setting
 * initial orientation) need to adapt to that
 */
let deviceOrientationControls = false;

export function hasDeviceOrientationControls() {
  return deviceOrientationControls;
}

export async function checkDeviceOrientationPermission(browser) {
  if (enablesDeviceOrientationControls(browser)) {
    if (requiresDeviceOrientationPermission()) {
      try {
        const response = await window.DeviceOrientationEvent.requestPermission();
        deviceOrientationControls = response == 'granted';
      } catch (e) {
        // In case of error, nothing we can do so can just leave things as is
        // and record there's no deviceOrientationControls
      }
    }

    deviceOrientationControls = true;
  }
}

function requiresDeviceOrientationPermission() {
  return typeof window.DeviceOrientationEvent?.requestPermission === 'function';
}

// VideoJS will try to enable DeviceOrientationControls
// on Android and iOS automatically (as we don't use the `motionControls: false` option)
function enablesDeviceOrientationControls(browser) {
  return browser.IS_ANDROID || browser.IS_IOS;
}
